module.exports = "/images/welcome2ed.jpg?8adade541cb8e6bf807ed79efe8b1cbf";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/welcome2ed.jpg
// module id = 2WeD
// module chunks = 0